export { default as CustomerCreate } from './create';
export { default as CustomerList } from './list';
export { default as CustomerView } from './view';
